import { makeStyles } from '@mui/styles';
import Loader from 'apollo-react/components/Loader';
import Typography from 'apollo-react/components/Typography';
import ClipboardPencil from 'apollo-react-icons/ClipboardPencil';
import React, { useState } from 'react';

import ActorsTable from './ActorsTable';
import { useFormSelector } from '../../../custom-hooks';
import { getUITA } from '../../../utils/commonUtils';
import { SS_CONTROL_TYPE } from '../../constants/form-manager.constants';
import { ROLE_MANAGEMENT_ACTIONS_TYPES } from '../../constants/runtime.constants';
import { getDataByController } from '../../selectors/runtime.selectors';

const useStyles = makeStyles({
  mainContainer: {
    marginTop: 10,
    marginBottom: 20,
    display: 'flex',
    flexWrap: 'no-wrap',
    gap: 15,
    overflowX: 'auto',
  },
  editorControlContainer: {
    display: 'flex',
    paddingLeft: 15,
  },
});

const SSRoleActorsManagement = ({ isEditor }) => {
  const classes = useStyles();

  const [isLoading, setIsLoading] = useState(false);

  const roleId = useFormSelector(getDataByController, {
    entityName: 'V_ROL_ROLE',
    fieldName: 'ROL_ID',
  });

  if (isEditor) {
    return (
      <div className={classes.editorControlContainer}>
        <Typography style={{ marginRight: 15 }}>
          {SS_CONTROL_TYPE.ROLE_ACTORS_MANAGEMENT}
        </Typography>
        <ClipboardPencil color="primary" />
      </div>
    );
  }

  const FILTER_ONLY_CURRENT_ACTORS_BY_ROLE = [
    {
      openGroup: false,
      fieldName: 'ACR_ROL_ID',
      sqlOperator: 'EQ',
      value: roleId,
      relationalOperator: 'AND',
      closeGroup: false,
    },
  ];

  return (
    <>
      <div className={classes.mainContainer} ui-ta={getUITA('FormCtrl', 'SSRoleActorsManagement')}>
        <ActorsTable
          entityName="V_ACR_ACTOR_ROLE"
          searchName="Current Actors"
          actionType={ROLE_MANAGEMENT_ACTIONS_TYPES.DELETE}
          buttonLabel="Delete From Role"
          roleId={roleId}
          setIsLoading={setIsLoading}
          customFilter={FILTER_ONLY_CURRENT_ACTORS_BY_ROLE}
        />
        <ActorsTable
          entityName="ACT_ACTOR"
          searchName="Available Actors"
          actionType={ROLE_MANAGEMENT_ACTIONS_TYPES.ASSIGN}
          buttonLabel="Assign To Role"
          roleId={roleId}
          setIsLoading={setIsLoading}
        />
      </div>
      {isLoading && <Loader isInner />}
    </>
  );
};

export default SSRoleActorsManagement;
